/** @jsxImportSource @emotion/react */
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomInputText, CustomInputWrap, UseToggle } from '../../components/inputs/CustomInput';
import {
  InputBox,
  SearchBox,
  SearchBoxRow,
  SearchButtonWrap,
  SearchCols,
  SearchRows,
} from '../../components/layouts/SearchBox';
import { IconButton } from '../../components/buttons/IconSVG';
import { Button } from '@mui/material';
import { ContentSection } from '../../components/layouts/ContentSection';
import { ContentFlex } from 'components/layouts/ContentFlex';
import MpCodeLv1Grid from './codemanagement/MpCodeLv1Grid';
import MpCodeLv2Grid from './codemanagement/MpCodeLv2Grid';
import MpCodeLv3Grid from './codemanagement/MpCodeLv3Grid';
import { getCommonCodeNames, getCommonCodeNamesCondition } from 'apis/admin/CommonCode';
import { Code } from 'models/common/CommonCode';
import { hasRole } from 'utils/SessionUtil';
/**
 * 개선목적모드관리 페이지
 */

const MpCodeManagementPage = () => {
  const searchRef = useRef<any>();
  const [hasAuth, setHasAuth] = useState<boolean>(false);

  const [gridRefresh, setRefresh] = useState<boolean>(false);
  const refresh = () => setRefresh(gridRefresh === false ? true : false);

  useEffect(() => {
    initCondition();
  }, []);

  const initCondition = async () => {
    if (hasRole('ADM') || hasRole('MP_QA_MANAGER')) {
      setHasAuth(true);
    }
  };

  return (
    <>
      <ContentFlex>
        <ContentSection className="section marginT0 width45p">
          <MpCodeLv1Grid hasAuth={hasAuth} onRefresh={refresh} />
        </ContentSection>
        <ContentSection className="section width50p">
          <MpCodeLv2Grid hasAuth={hasAuth} onRefresh={refresh} gridRefresh={gridRefresh} />
        </ContentSection>
      </ContentFlex>
      <ContentSection className="section ">
        <MpCodeLv3Grid hasAuth={hasAuth} gridRefresh={gridRefresh} />
      </ContentSection>
    </>
  );
};

export default MpCodeManagementPage;
